import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Landing sections - exact original design split into components
import LandingNavbar from './landing/LandingNavbar';
import LandingHero from './landing/LandingHero';
import LandingHowItWorks from './landing/LandingHowItWorks';
import LandingBenefits from './landing/LandingBenefits';
import LandingPricing from './landing/LandingPricing';

export default function LandingFrugal() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  // Auto-redirect if already logged in
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) navigate('/dashboard', { replace: true });
  }, [navigate]);

  const toggleLanguage = () => {
    const newLang = i18n.language === 'es' ? 'en' : 'es';
    i18n.changeLanguage(newLang);
    localStorage.setItem('i18nextLng', newLang);
  };

  const handleStartFreeTrial = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login?plan=frugal');
      return;
    }
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v2/frugal/subscription/activate-trial`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      if (response.ok) {
        navigate('/frugal-wizard');
      } else {
        navigate('/login?plan=frugal');
      }
    } catch (error) {
      console.error('Error activating trial:', error);
      navigate('/login?plan=frugal');
    }
  };

  // Auto-scroll to pricing if coming from Login
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const scrollTo = params.get('scrollTo');
    if (scrollTo === 'pricing') {
      setTimeout(() => {
        const pricingSection = document.getElementById('pricing');
        if (pricingSection) {
          pricingSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, []);

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F9F9F6', color: '#2C2C2C', paddingTop: 'env(safe-area-inset-top, 0px)' }}>
      <LandingNavbar t={t} i18n={i18n} toggleLanguage={toggleLanguage} navigate={navigate} />
      <LandingHero t={t} />
      <LandingHowItWorks t={t} />
      <LandingBenefits t={t} />
      <LandingPricing t={t} navigate={navigate} handleStartFreeTrial={handleStartFreeTrial} />
    </div>
  );
}
